import { PageNanoID } from './pagesTypes';
import { SearchFilterNanoID } from '../searchFilters/searchFiltersTypes';

const basePath = '/pages';

const basePublicPath = '/public/pages';

export class PagePath {
  static index() {
    return basePath;
  }

  static show(pageNanoID: PageNanoID) {
    return `${basePath}/${pageNanoID}`;
  }

  static publicShow(pageNanoID: PageNanoID) {
    return `${basePublicPath}/${pageNanoID}`;
  }

  static filters(searchFilterNanoId: SearchFilterNanoID) {
    return `${basePath}/filters/${searchFilterNanoId}`;
  }
}
